module.exports = __webpack_public_path__ + "img/20191021163108440.0efd7f1a.jpg";